<div class="main-content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header card-header-danger">
            <h4>Manage Escalation Matrix</h4>
          </div>

          <div class="card-body">
            <form [formGroup]="EscalationForm">
              <div class="row">

                <div class="col-md-8">
                  <div class="row">
                    <div class="col-md-4 control-label"> <label>Assignment Group</label></div>
                    <div class="col-md-8">
                      <p-dropdown [options]="groupList" optionLabel="GroupName" placeholder="--Select--" (onChange)="Displaygroupdetail()" formControlName="SelectedGroup"
                      filter="true" [showClear]="true">
                    </p-dropdown>
                    <mat-error
                    *ngIf="GetFormControls('SelectedGroup').invalid && (GetFormControls('SelectedGroup').dirty || GetFormControls('SelectedGroup').touched)"
                    class="ValidationError">
                    <mat-error *ngIf="GetFormControls('SelectedGroup').errors.required">
                      Assignment Group is required.
                    </mat-error>
                  </mat-error>   
                  </div>
                  </div>
                </div>

                <div class="col-md-4">
                 
                  </div>
                  <div class="clearfix"></div>
                  
              </div>

              <div class="row">

                <div class="col-md-8">
                  <div class="row">
                    <div class="mat-elevation-z8 top-margin-border">
                      <table mat-table [dataSource]="EscalationDataSource" style="width:100% !important">
             
                        <ng-container matColumnDef="#">
                          <th mat-header-cell *matHeaderCellDef > # </th>
                          <td mat-cell *matCellDef="let element;  let j = index;"> {{j+1}} </td>
                        </ng-container>

                        <ng-container matColumnDef="Id">
                          <th mat-header-cell *matHeaderCellDef> Id </th>
                          <td mat-cell *matCellDef="let element"> {{element.Id}} </td>
                        </ng-container>
              
                        <ng-container matColumnDef="GroupName">
                          <th mat-header-cell *matHeaderCellDef class="header-color">Assignment Group</th>
                          <td mat-cell *matCellDef="let element"> {{element.GroupName}} </td>
                        </ng-container>
        
                        <ng-container matColumnDef="ItemId" >
                          <th mat-header-cell *matHeaderCellDef> ItemId </th>
                          <td mat-cell *matCellDef="let element" > {{element.ItemId}} </td>
                        </ng-container>

                        <ng-container matColumnDef="Category">
                          <th mat-header-cell *matHeaderCellDef class="header-color"> Category </th>
                          <td mat-cell *matCellDef="let element"> {{element.CategoryName}} </td>
                        </ng-container>
  
                        <ng-container matColumnDef="SubCategory">
                          <th mat-header-cell *matHeaderCellDef class="header-color"> Sub-Category </th>
                          <td mat-cell *matCellDef="let element"> {{element.SubCategoryName}} </td>
                        </ng-container>
        
                        <ng-container matColumnDef="ItemName">
                          <th mat-header-cell *matHeaderCellDef class="header-color"> Item </th>
                          <td mat-cell *matCellDef="let element"> {{element.ItemName}} </td>
                        </ng-container>
  
                      
                        <ng-container matColumnDef="GroupId">
                          <th mat-header-cell *matHeaderCellDef> Group Id </th>
                          <td mat-cell *matCellDef="let element"> {{element.GroupId}} </td>
                        </ng-container>
            
              
                          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                      </table>
            
            <!-- <mat-paginator [pageSizeOptions]="[5, 10, 20]" [pageSize]="5"> </mat-paginator> -->
          </div>
                  </div>
                </div>

                <div class="col-md-4">
                 
                  </div>
                  <div class="clearfix"></div>
                  <br>
              </div>

              <div class="row">

                <div class="col-md-8">
                  <div class="row">
                    <div class="col-md-4 control-label"> <label>Escalation Sequence No</label></div>
                    <div class="col-md-7">
                      <p-dropdown [options]="EscalationList" optionLabel="KeywordName" placeholder="--Select--" formControlName="SelectedEscalation"
                      filter="true" [showClear]="true">
                    </p-dropdown>
                    <mat-error
                    *ngIf="GetFormControls('SelectedEscalation').invalid && (GetFormControls('SelectedEscalation').dirty || GetFormControls('SelectedEscalation').touched)"
                    class="ValidationError">
                    <mat-error *ngIf="GetFormControls('SelectedEscalation').errors.required">
                      Escalation Sequence No is required.
                    </mat-error>
                  </mat-error>    
                  
                  </div>
                  <div class="col-md-1"></div>
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="row">
                    <div class="col-md-6 control-label"> <label>Time Period(in Hrs.)</label></div>
           
                      <div class="col-md-6">  
                       <input type="text" class="form-control" numbersOnly maxlength="3" formControlName="Hour">
                       <mat-error
                       *ngIf="GetFormControls('Hour').invalid && (GetFormControls('Hour').dirty || GetFormControls('Hour').touched)"
                       class="ValidationError">
                       <mat-error *ngIf="GetFormControls('Hour').errors.required">
                         Time is required.
                       </mat-error>
                     </mat-error>
                      </div>
                    </div>
                  </div>
                  <div class="clearfix"></div>
                  <br>
              </div>

              <div class="row">

                <div class="col-md-8">
                  <div class="row">
                    <div class="col-md-4 control-label"> <label>Employee Name</label></div>
                    <div class="col-md-8">
                  
                      <p-autoComplete formControlName="EmpName" [suggestions]="requesterList"
                        (completeMethod)="SearchActiveEmployee($event)" placeholder="search name"
                        field="EmployeeName" [forceSelection]="true" class="width-employee" [minLength]="3" size="37"
                        (onSelect)="SetEmployeeDetails($event)" item [multiple]="true"  (onUnselect)="UnselectEmpName()" (onClear)="clearAutoComplete('EmpName')"
                      >
                    </p-autoComplete>
                    <mat-error
                    *ngIf="GetFormControls('EmpName').invalid && (GetFormControls('EmpName').dirty || GetFormControls('EmpName').touched)"
                    class="ValidationError">
                    <mat-error *ngIf="GetFormControls('EmpName').errors.required">
                      Employee Name is required.
                    </mat-error>
                  </mat-error>    
                  
                  </div>
                  </div>
                </div>

                <div class="col-md-4">
                  <button type="submit"  style="margin-top: 10px;margin-left: 20px;margin-right: 50px;" class="btn-primary1" (click)="Adddata()" >Submit</button>
                  <button class="btn-primary1" (click)="Export()">Export as Excel</button>
                  </div>
                  <div class="clearfix"></div>
                  
          <!-- Added by Anmol Kaur -->        
                  <div class="cardSearch2">
                <div class="card-header2 form-control2" data-toggle="collapse" href="#collapseSearch" (click)="showhide()" role="button"
                    aria-expanded="false" aria-controls="collapseSearch">
                    <header class="panel-heading">
                        <h5 class="panel-title">Search(Tap to Expand)</h5>
                    </header>
                </div>
                <div *ngIf="Ispanelshow" id="collapseSearch">
                    <div class="card-body2">
                        <div class="row">
                            <div class="form-group2 col-md-6">
                                <label class="required" style="width: 120px;">Employee Name</label>
                                <p-autoComplete formControlName="Employee" [suggestions]="requesterList"
                                (completeMethod)="SearchActiveEmployee($event)" placeholder="Employee Name"
                                field="EmployeeName" [forceSelection]="true" [minLength]="3" size="57"
                                (onSelect)="SetEmployeeDetails($event)"  (onClear)="clearAutoCompleteSearch('Employee')"
                                >
                            </p-autoComplete>
                            </div>
                            <div class="form-group2 col-md-6">
                                <label class="required">Assignment Group Name</label>
                                <p-dropdown [options]="groupList" optionLabel="GroupName"
                                (onChange)="SetGroupId($event)"
                                 placeholder="--Select--" formControlName="GroupSearch"
                                filter="true" [showClear]="true">
                              </p-dropdown>
                            </div>
                        </div>
                      
                        <div class="clearfix"></div>
                      <div class="row">
      
                        <div class="col-md-12" style="text-align: center;">
                          <button class="btn-primary1" (click)="Exit()">Exit</button>
                          <button class="btn-primary1" (click)="ResetData()">Reset</button>
                          <button type="submit" style="margin-top: 10px;margin-right: 80px;" value="Submit" class="btn-primary1" (click)="GetResult()" >Get Result</button>
      
                        </div>
                        
                        
                      </div>
                    </div>
                </div>
            </div>
              </div>

     <!-- Ended by Anmol Kaur -->
              <div class="clearfix"></div>
                <div class="row">
                 
                <div class="col-md-12">
                  <div class="mat-elevation-z8 top-margin-border" #TABLE>
                    <table mat-table [dataSource]="EscalationListDataSource" #table style="width:100% !important">
           
                      <!-- <ng-container matColumnDef="#">
                        <th mat-header-cell *matHeaderCellDef> # </th>
                        <td mat-cell *matCellDef="let element;  let j = index;"> {{j+1}} </td>
                      </ng-container> -->

                      <ng-container matColumnDef="Id">
                        <th mat-header-cell *matHeaderCellDef> Id </th>
                        <td mat-cell *matCellDef="let element"> {{element.Id}} </td>
                      </ng-container>
            
                      <ng-container matColumnDef="GroupName" >
                        <th mat-header-cell *matHeaderCellDef >Assignment Group</th>
                        <td mat-cell *matCellDef="let element" style="cursor:pointer;color:blue; text-decoration: underline;" (click)="rowclickdata(element.Id)"> {{element.GroupName}} </td>
                      </ng-container>
      
                      <ng-container matColumnDef="EmpGPN" >
                        <th mat-header-cell *matHeaderCellDef> Employee GPN </th>
                        <td mat-cell *matCellDef="let element" > {{element.EmpGPN}} </td>
                      </ng-container>

                      <ng-container matColumnDef="EmpMail" >
                        <th mat-header-cell *matHeaderCellDef> EmpMail </th>
                        <td mat-cell *matCellDef="let element" > {{element.EmpMail}} </td>
                      </ng-container>

                      <ng-container matColumnDef="EscalationSequence">
                        <th mat-header-cell *matHeaderCellDef > Escalation Sequence No </th>
                        <td mat-cell *matCellDef="let element"> {{element.KeywordName}} </td>
                      </ng-container>

                      <ng-container matColumnDef="EscalationSequenceNo" >
                        <th mat-header-cell *matHeaderCellDef> EscalationSequenceNo </th>
                        <td mat-cell *matCellDef="let element" > {{element.KeywordValue}} </td>
                      </ng-container>

                      <ng-container matColumnDef="Hour">
                        <th mat-header-cell *matHeaderCellDef > Hour </th>
                        <td mat-cell *matCellDef="let element"> {{element.TimePeriod}} </td>
                      </ng-container>
      
                      <ng-container matColumnDef="EmployeeName" >
                        <th mat-header-cell *matHeaderCellDef> Employee Name </th>
                        <td mat-cell *matCellDef="let element"> {{element.EmpName}} </td>
                      </ng-container>

                    
                      <ng-container matColumnDef="GroupId">
                        <th mat-header-cell *matHeaderCellDef> Group Id </th>
                        <td mat-cell *matCellDef="let element"> {{element.GroupId}} </td>
                      </ng-container>

                      <ng-container matColumnDef="Status">
                        <th mat-header-cell *matHeaderCellDef> Status </th>
                        <td mat-cell *matCellDef="let element"> {{element.Status}} </td>
                      </ng-container>
            
                      <ng-container matColumnDef="Update">
                        <th mat-header-cell *matHeaderCellDef> Action </th>
                        <td mat-cell *matCellDef="let element;  let j = index;" style="cursor:pointer;color:blue; text-decoration: underline;" (click)="statusupdatedata(element.Id)"> Update Status </td>
                    
                      </ng-container>
          
            
                        <tr mat-header-row *matHeaderRowDef="displayedColumns1"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns1;"></tr>
                    </table>
                    <mat-paginator  #paginator
                    [length]="_global.length"
                    [pageIndex]="_global.pageIndex"
                    [pageSize]="_global.RecordSize"
                    [pageSizeOptions]="[5, 10, 25, 100]"
                    (page)="onPaginateChange1($event)"></mat-paginator>
          <!-- <mat-paginator [pageSizeOptions]="[5, 10, 20]" [pageSize]="5"> </mat-paginator> -->
        </div>
    
              </div>
              
              
                </div>
            </form>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>

